export default __webpack_public_path__ + "static/media/aristeuvieira.eff3592f.jpg";